export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50 scroll-mt-16">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 mb-4">关于我们</h2>
        <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/60">
          <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-6">
            萝卜影视是一个专注于电影在线观看的综合性平台，致力于为影迷提供最新电影上线信息、热门电影排行榜与高品质的电影在线观看服务。
            我们汇聚了涵盖动作、科幻、悬疑、喜剧、爱情、动画等全品类电影大全，从院线热映到经典佳片应有尽有。
          </p>
          <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-6">
            平台每日更新片库，确保最新电影上线后第一时间与观众见面。我们坚持免费高清的观影理念，采用先进的流媒体技术，
            让每一位影迷都能享受到不缓冲、超清画质的沉浸式观影体验。
          </p>
          <p className="text-sm md:text-base text-foreground-400 leading-relaxed">
            萝卜影视不仅是看电影的地方，更是影迷交流的社区。热门话题讨论、精选专题策划、深度影评推荐，
            让你在观影之余发现更多好片，结识志同道合的影友。
          </p>
        </div>
      </div>
    </section>
  );
}